import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, normalizeClass as _normalizeClass, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7e69faa8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "app-boot"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 2,
  class: "row onboarding-progress__container"
}
const _hoisted_4 = { class: "col-md-12 px-0" }
const _hoisted_5 = { class: "dt-container--progress d-flex align-items-center flex-wrap flex-md-nowrap" }
const _hoisted_6 = { class: "flex-grow-1" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "mt-0 d-flex align-items-center primary-color" }, "You still need to finish setting up Ditto.", -1))
const _hoisted_8 = { class: "m-0 primary-color" }
const _hoisted_9 = {
  key: 3,
  class: "top-menu new-menu"
}
const _hoisted_10 = { class: "top-menu__org-info" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "hamburger",
  "aria-label": "Open Navigation Menu"
}, [
  /*#__PURE__*/_createElementVNode("div", { "aria-hidden": "true" }),
  /*#__PURE__*/_createElementVNode("div", { "aria-hidden": "true" }),
  /*#__PURE__*/_createElementVNode("div", { "aria-hidden": "true" })
], -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { class: "top-menu__logo" }
const _hoisted_14 = { class: "Header-logo-wrapper" }
const _hoisted_15 = ["src"]
const _hoisted_16 = ["src"]
const _hoisted_17 = {
  key: 0,
  class: "top-menu__org-name"
}
const _hoisted_18 = {
  key: 0,
  class: "account-icons"
}
const _hoisted_19 = { class: "release-notification" }
const _hoisted_20 = {
  key: 0,
  class: "notify-dot release-notification__icon"
}
const _hoisted_21 = {
  class: "top-menu__account-icon",
  viewBox: "0 0 24 24"
}
const _hoisted_22 = ["d"]
const _hoisted_23 = {
  class: "top-menu__account-dropdown-icon",
  viewBox: "0 0 24 24"
}
const _hoisted_24 = ["d"]
const _hoisted_25 = { class: "el-popover__subnav-heading" }
const _hoisted_26 = { class: "el-popover__subnav-title" }
const _hoisted_27 = { class: "el-popover__subnav" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", {
  "aria-hidden": "true",
  class: "top-menu__divider"
}, null, -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  target: "_blank",
  rel: "noreferrer noopener",
  href: "http://airsquirrels.com/ditto/product/feedback"
}, "Feedback", -1))
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "ditto-main-portal" }, null, -1))
const _hoisted_32 = {
  class: "side-nav",
  ref: "sideNav"
}
const _hoisted_33 = {
  class: "side-nav__icon",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "0 0 128 128",
  style: {"enable-background":"new 0 0 128 128"},
  "xml:space": "preserve"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M120.1,44c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.2-0.2-0.3-0.3-0.5c0,0,0,0,0,0c-2-3.2-6.2-4.4-9.6-2.6c-1.2,0.6-2.2,1.6-2.9,2.7 c-1.4,2.3-1.3,5-0.2,7.1c0,0.1,0,0.2,0.1,0.2c2.8,5.4,4.6,11.3,5.2,17.5H101c-2.7,0-4.9,2.2-4.9,4.9c0,2.7,2.2,4.9,4.9,4.9h11.3 c-0.8,8.5-3.8,16.5-8.7,23.3c-0.2,0.2-0.3,0.5-0.5,0.7l0,0c-0.5,0.7-1,1.3-1.5,2l-8-8c-1.9-1.9-5-1.9-6.9,0c-1.9,1.9-1.9,5,0,6.9 c0,0,13.2,13.2,13.5,13.5c1.4,1.3,3.2,1.9,4.9,1.9c1.9,0,3.8-0.7,5.2-2.2c0.1-0.1,0.1-0.1,0.2-0.2c0,0,0,0,0,0 c10.7-11.7,16.6-26.8,16.6-42.7C127.2,62.9,124.7,52.9,120.1,44z M98.9,28.9c2.1-3.5,1-7.9-2.5-10c-9.8-5.9-21.1-9-32.6-9 C28.9,9.8,0.5,38.2,0.5,73.2c0,15.9,5.9,31.1,16.7,42.8c1.4,1.6,3.4,2.4,5.4,2.4c1.8,0,3.5-0.6,4.9-1.9c3-2.7,3.2-7.4,0.4-10.3 c-7.2-7.8-11.5-17.6-12.6-28h11.3c2.7,0,4.9-2.2,4.9-4.9s-2.2-4.9-4.9-4.9H15.4c1-9.8,4.9-18.7,10.8-25.9l8,8c1,1,2.2,1.4,3.4,1.4 c1.2,0,2.5-0.5,3.4-1.4c1.9-1.9,1.9-5,0-6.9l-8-8c8.4-6.9,19.1-11,30.8-11c6.4,0,12.7,1.3,18.5,3.7L64.1,58.6c-0.1,0-0.2,0-0.2,0 c-8.1,0-14.6,6.5-14.6,14.6s6.5,14.6,14.6,14.6s14.6-6.5,14.6-14.6c0-2.6-0.7-5-1.8-7.1L98.9,28.9z M63.8,78c-2.7,0-4.9-2.2-4.9-4.9 s2.2-4.9,4.9-4.9c2.7,0,4.9,2.2,4.9,4.9S66.5,78,63.8,78z" }, null, -1))
const _hoisted_35 = [
  _hoisted_34
]
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "side-nav__link-text" }, "Dashboard", -1))
const _hoisted_37 = {
  class: "side-nav__icon",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "0 0 128 128",
  style: {"enable-background":"new 0 0 128 128"},
  "xml:space": "preserve"
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M120.1,44c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.2-0.2-0.3-0.3-0.5c0,0,0,0,0,0c-2-3.2-6.2-4.4-9.6-2.6c-1.2,0.6-2.2,1.6-2.9,2.7 c-1.4,2.3-1.3,5-0.2,7.1c0,0.1,0,0.2,0.1,0.2c2.8,5.4,4.6,11.3,5.2,17.5H101c-2.7,0-4.9,2.2-4.9,4.9c0,2.7,2.2,4.9,4.9,4.9h11.3 c-0.8,8.5-3.8,16.5-8.7,23.3c-0.2,0.2-0.3,0.5-0.5,0.7l0,0c-0.5,0.7-1,1.3-1.5,2l-8-8c-1.9-1.9-5-1.9-6.9,0c-1.9,1.9-1.9,5,0,6.9 c0,0,13.2,13.2,13.5,13.5c1.4,1.3,3.2,1.9,4.9,1.9c1.9,0,3.8-0.7,5.2-2.2c0.1-0.1,0.1-0.1,0.2-0.2c0,0,0,0,0,0 c10.7-11.7,16.6-26.8,16.6-42.7C127.2,62.9,124.7,52.9,120.1,44z M98.9,28.9c2.1-3.5,1-7.9-2.5-10c-9.8-5.9-21.1-9-32.6-9 C28.9,9.8,0.5,38.2,0.5,73.2c0,15.9,5.9,31.1,16.7,42.8c1.4,1.6,3.4,2.4,5.4,2.4c1.8,0,3.5-0.6,4.9-1.9c3-2.7,3.2-7.4,0.4-10.3 c-7.2-7.8-11.5-17.6-12.6-28h11.3c2.7,0,4.9-2.2,4.9-4.9s-2.2-4.9-4.9-4.9H15.4c1-9.8,4.9-18.7,10.8-25.9l8,8c1,1,2.2,1.4,3.4,1.4 c1.2,0,2.5-0.5,3.4-1.4c1.9-1.9,1.9-5,0-6.9l-8-8c8.4-6.9,19.1-11,30.8-11c6.4,0,12.7,1.3,18.5,3.7L64.1,58.6c-0.1,0-0.2,0-0.2,0 c-8.1,0-14.6,6.5-14.6,14.6s6.5,14.6,14.6,14.6s14.6-6.5,14.6-14.6c0-2.6-0.7-5-1.8-7.1L98.9,28.9z M63.8,78c-2.7,0-4.9-2.2-4.9-4.9 s2.2-4.9,4.9-4.9c2.7,0,4.9,2.2,4.9,4.9S66.5,78,63.8,78z" }, null, -1))
const _hoisted_39 = [
  _hoisted_38
]
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "side-nav__link-text" }, "Users", -1))
const _hoisted_41 = {
  class: "side-nav__icon",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "0 0 128 128",
  style: {"enable-background":"new 0 0 128 128"},
  "xml:space": "preserve"
}
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M120.1,44c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.2-0.2-0.3-0.3-0.5c0,0,0,0,0,0c-2-3.2-6.2-4.4-9.6-2.6c-1.2,0.6-2.2,1.6-2.9,2.7 c-1.4,2.3-1.3,5-0.2,7.1c0,0.1,0,0.2,0.1,0.2c2.8,5.4,4.6,11.3,5.2,17.5H101c-2.7,0-4.9,2.2-4.9,4.9c0,2.7,2.2,4.9,4.9,4.9h11.3 c-0.8,8.5-3.8,16.5-8.7,23.3c-0.2,0.2-0.3,0.5-0.5,0.7l0,0c-0.5,0.7-1,1.3-1.5,2l-8-8c-1.9-1.9-5-1.9-6.9,0c-1.9,1.9-1.9,5,0,6.9 c0,0,13.2,13.2,13.5,13.5c1.4,1.3,3.2,1.9,4.9,1.9c1.9,0,3.8-0.7,5.2-2.2c0.1-0.1,0.1-0.1,0.2-0.2c0,0,0,0,0,0 c10.7-11.7,16.6-26.8,16.6-42.7C127.2,62.9,124.7,52.9,120.1,44z M98.9,28.9c2.1-3.5,1-7.9-2.5-10c-9.8-5.9-21.1-9-32.6-9 C28.9,9.8,0.5,38.2,0.5,73.2c0,15.9,5.9,31.1,16.7,42.8c1.4,1.6,3.4,2.4,5.4,2.4c1.8,0,3.5-0.6,4.9-1.9c3-2.7,3.2-7.4,0.4-10.3 c-7.2-7.8-11.5-17.6-12.6-28h11.3c2.7,0,4.9-2.2,4.9-4.9s-2.2-4.9-4.9-4.9H15.4c1-9.8,4.9-18.7,10.8-25.9l8,8c1,1,2.2,1.4,3.4,1.4 c1.2,0,2.5-0.5,3.4-1.4c1.9-1.9,1.9-5,0-6.9l-8-8c8.4-6.9,19.1-11,30.8-11c6.4,0,12.7,1.3,18.5,3.7L64.1,58.6c-0.1,0-0.2,0-0.2,0 c-8.1,0-14.6,6.5-14.6,14.6s6.5,14.6,14.6,14.6s14.6-6.5,14.6-14.6c0-2.6-0.7-5-1.8-7.1L98.9,28.9z M63.8,78c-2.7,0-4.9-2.2-4.9-4.9 s2.2-4.9,4.9-4.9c2.7,0,4.9,2.2,4.9,4.9S66.5,78,63.8,78z" }, null, -1))
const _hoisted_43 = [
  _hoisted_42
]
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "side-nav__link-text" }, "Organizations", -1))
const _hoisted_45 = {
  class: "side-nav__icon",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "0 0 128 128",
  style: {"enable-background":"new 0 0 128 128"},
  "xml:space": "preserve"
}
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M95.8,106.6H31.9c-2.4,0-4.4,2-4.4,4.4v2.6c0,2.4,2,4.4,4.4,4.4h63.9c2.4,0,4.4-2,4.4-4.4V111 C100.2,108.6,98.2,106.6,95.8,106.6z" }, null, -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M122.8,14H4.9c-2.4,0-4.4,2-4.4,4.4V98c0,2.4,2,4.4,4.4,4.4h117.8c2.4,0,4.4-2,4.4-4.4V18.4C127.2,16,125.2,14,122.8,14z" }, null, -1))
const _hoisted_48 = [
  _hoisted_46,
  _hoisted_47
]
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "side-nav__link-text" }, "Receivers", -1))
const _hoisted_50 = {
  class: "side-nav__icon",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "0 0 40 40",
  style: {"enable-background":"new 0 0 128 128"},
  "xml:space": "preserve"
}
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M31.328,30.126l-5.245,2.421l-5.154,2.379  c-0.21,0.097-0.437,0.081-0.632-0.043s-0.304-0.324-0.304-0.556V21.628c0-0.791,0.433-1.467,1.15-1.797l4.941-2.28l5.97-2.756  c0.21-0.097,0.437-0.082,0.632,0.043c0.195,0.125,0.304,0.324,0.304,0.557V27.53C32.989,28.671,32.364,29.648,31.328,30.126z   M31.809,11.954l-5.726,2.863l-5.713,2.857c-0.896,0.448-1.859,0.448-2.755,0l-5.713-2.857l-5.726-2.863  c-0.229-0.115-0.365-0.334-0.365-0.591c0-0.256,0.136-0.475,0.365-0.59l5.726-2.863l5.615-2.808c0.959-0.479,1.992-0.479,2.952,0  l5.614,2.808l5.726,2.863c0.229,0.115,0.365,0.334,0.365,0.59C32.173,11.62,32.038,11.839,31.809,11.954z M11.901,17.55l4.941,2.28  c0.717,0.331,1.15,1.008,1.15,1.797v12.699c0,0.232-0.109,0.431-0.304,0.556c-0.195,0.125-0.422,0.141-0.632,0.043l-5.155-2.379  l-5.245-2.421c-1.037-0.478-1.662-1.455-1.662-2.596V15.394c0-0.232,0.109-0.432,0.305-0.557c0.195-0.125,0.422-0.14,0.632-0.043  L11.901,17.55z",
  style: {"fill-rule":"evenodd","clip-rule":"evenodd"}
}, null, -1))
const _hoisted_52 = [
  _hoisted_51
]
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "side-nav__link-text" }, "Rooms", -1))
const _hoisted_54 = {
  class: "side-nav__icon",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "0 0 128 128",
  style: {"enable-background":"new 0 0 128 128"},
  "xml:space": "preserve"
}
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M85.8,47.3c0,12.7-10.4,23.1-23.2,23.1c-12.8,0-23.2-10.3-23.2-23.1c0-12.7,10.4-23.1,23.2-23.1 C75.4,24.2,85.8,34.5,85.8,47.3 M109.8,47.3c0-25.5-20.7-46.1-46.3-46.1c-25.6,0-46.3,20.6-46.3,46.1c0,11.2,4,21.5,10.7,29.5 L63.5,128l36.2-52c1.3-1.6,2.5-3.3,3.6-5.1l0.4-0.5h-0.1C107.5,63.6,109.8,55.7,109.8,47.3" }, null, -1))
const _hoisted_56 = [
  _hoisted_55
]
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "side-nav__link-text" }, "Locations", -1))
const _hoisted_58 = { class: "side-nav__link" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "side-nav__icon",
  viewBox: "0 0 100 100"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M91.5,22h-83c-1.1,0-2,0.9-2,2v48c0,1.1,0.9,2,2,2h83c1.1,0,2-0.9,2-2V24C93.5,22.9,92.6,22,91.5,22zM13.7,34.5H51c0.5,0,0.9,0.4,0.9,0.9s-0.4,0.9-0.9,0.9H13.7c-0.5,0-0.9-0.4-0.9-0.9S13.2,34.5,13.7,34.5z M51,60.3H13.7c-0.5,0-0.9-0.4-0.9-0.9s0.4-0.9,0.9-0.9H51c0.5,0,0.9,0.4,0.9,0.9S51.5,60.3,51,60.3z M78.1,52.3H13.7c-0.5,0-0.9-0.4-0.9-0.9s0.4-0.9,0.9-0.9h64.4c0.5,0,0.9,0.4,0.9,0.9S78.6,52.3,78.1,52.3z M78.1,44.3H13.7c-0.5,0-0.9-0.4-0.9-0.9s0.4-0.9,0.9-0.9h64.4c0.5,0,0.9,0.4,0.9,0.9S78.6,44.3,78.1,44.3z" })
], -1))
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "side-nav__link-text" }, "Signage", -1))
const _hoisted_61 = ["d"]
const _hoisted_62 = {
  key: 0,
  class: "el-popover__subnav-heading"
}
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "el-popover__subnav-title" }, "Signage", -1))
const _hoisted_64 = [
  _hoisted_63
]
const _hoisted_65 = { class: "el-popover__subnav" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Lists", -1))
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "side-nav__link-text" }, "Lists", -1))
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "side-nav__link-text" }, "Layouts", -1))
const _hoisted_69 = {
  class: "side-nav__icon",
  version: "1.1",
  id: "Layer_1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "0 0 100 100",
  style: {"enable-background":"new 0 0 100 100"},
  "xml:space": "preserve"
}
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("g", null, [
  /*#__PURE__*/_createElementVNode("path", {
    class: "st0",
    d: "M81.5,71.8l-6.2-6.4c-0.7-0.7-1.1-1.7-1.1-2.6C74.1,41,72.4,23.4,55.6,20.3v-3.1c0-3.1-2.5-5.6-5.6-5.6l0,0c-3.1,0-5.6,2.5-5.6,5.6v3.1C27.6,23.4,25.9,41,25.8,62.7c0,1-0.4,1.9-1.1,2.6l-6.2,6.4c-0.2,0.2-0.4,0.6-0.4,0.9v2.5c0,0.7,0.6,1.3,1.3,1.3H50h30.5c0.7,0,1.3-0.6,1.3-1.3v-2.5C81.9,72.3,81.7,72,81.5,71.8z"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    class: "st0",
    d: "M50,88.4c4.6,0,8.4-3.7,8.4-8.4H41.6C41.6,84.7,45.4,88.4,50,88.4z"
  })
], -1))
const _hoisted_71 = [
  _hoisted_70
]
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "side-nav__link-text" }, "Alerts", -1))
const _hoisted_73 = { class: "side-nav__link" }
const _hoisted_74 = {
  class: "side-nav__icon",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "0 0 512 512",
  style: {"enable-background":"new 0 0 128 128"},
  "xml:space": "preserve"
}
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M409.9,428.1h-43.8h-87.6v-8.8v-13.1v-35c0-4.8-3.9-8.8-8.8-8.8h-26.3c-4.8,0-8.8,3.9-8.8,8.8v35 v13.1v8.8H147h-43.8c-12.1,0-21.9-9.8-21.9-21.9s9.8-21.9,21.9-21.9h21.9V99.5c0-12.1,9.8-21.9,21.9-21.9h219.1 c12.1,0,21.9,9.8,21.9,21.9v284.8h21.9c12.1,0,21.9,9.8,21.9,21.9S422,428.1,409.9,428.1z M234.7,152.1c0-4.8-3.9-8.8-8.8-8.8 h-26.3c-4.9,0-8.8,3.9-8.8,8.8v26.3c0,4.8,3.9,8.8,8.8,8.8h26.3c4.8,0,8.8-3.9,8.8-8.8V152.1z M234.7,217.8c0-4.8-3.9-8.8-8.8-8.8 h-26.3c-4.9,0-8.8,3.9-8.8,8.8v26.3c0,4.8,3.9,8.8,8.8,8.8h26.3c4.8,0,8.8-3.9,8.8-8.8V217.8z M234.7,283.5c0-4.8-3.9-8.8-8.8-8.8 h-26.3c-4.9,0-8.8,3.9-8.8,8.8v26.3c0,4.8,3.9,8.8,8.8,8.8h26.3c4.8,0,8.8-3.9,8.8-8.8V283.5z M322.3,152.1c0-4.8-3.9-8.8-8.8-8.8 h-26.3c-4.9,0-8.8,3.9-8.8,8.8v26.3c0,4.8,3.9,8.8,8.8,8.8h26.3c4.8,0,8.8-3.9,8.8-8.8V152.1z M322.3,217.8c0-4.8-3.9-8.8-8.8-8.8 h-26.3c-4.9,0-8.8,3.9-8.8,8.8v26.3c0,4.8,3.9,8.8,8.8,8.8h26.3c4.8,0,8.8-3.9,8.8-8.8V217.8z M322.3,283.5c0-4.8-3.9-8.8-8.8-8.8 h-26.3c-4.9,0-8.8,3.9-8.8,8.8v26.3c0,4.8,3.9,8.8,8.8,8.8h26.3c4.8,0,8.8-3.9,8.8-8.8V283.5z" }, null, -1))
const _hoisted_76 = [
  _hoisted_75
]
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "side-nav__link-text" }, "My Organization", -1))
const _hoisted_78 = ["d"]
const _hoisted_79 = {
  key: 0,
  class: "el-popover__subnav-heading"
}
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "el-popover__subnav-title" }, "My Organization", -1))
const _hoisted_81 = [
  _hoisted_80
]
const _hoisted_82 = { class: "el-popover__subnav" }
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Company", -1))
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "side-nav__link-text" }, "Company", -1))
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "side-nav__link-text" }, "Customization", -1))
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "side-nav__link-text" }, "Deployment", -1))
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "side-nav__link-text" }, "Billing", -1))
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "side-nav__link-text" }, "Reports", -1))
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "side-nav__link-text" }, "Alert Servers", -1))
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nav__footer-spacer",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_91 = ["src"]
const _hoisted_92 = { viewBox: "0 0 24 24" }
const _hoisted_93 = ["d"]
const _hoisted_94 = ["src"]
const _hoisted_95 = {
  key: 1,
  class: "app-view"
}
const _hoisted_96 = { class: "app-view-stack" }
const _hoisted_97 = { class: "app-view__help" }
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "py-2" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode("Check out our "),
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://help.airsquirrels.com/ditto",
      target: "_blank",
      rel: "noreferrer noopener"
    }, "knowledge base"),
    /*#__PURE__*/_createTextVNode(" or open a ticket to get in touch.")
  ])
], -1))
const _hoisted_99 = { class: "app-view__support" }
const _hoisted_100 = {
  href: "https://help.airsquirrels.com/ditto/kb-tickets/new",
  target: "_blank",
  rel: "noreferrer noopener"
}
const _hoisted_101 = { style: {"width":"99%"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Onboarding = _resolveComponent("Onboarding")!
  const _component_ExpiredSubscrption = _resolveComponent("ExpiredSubscrption")!
  const _component_el_progress = _resolveComponent("el-progress")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_affix = _resolveComponent("el-affix")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", {
    id: "app",
    class: _normalizeClass({ transparent: '$route.meta && !$route.meta.noAuth', 'room-sign-mode': _ctx.roomSignMode, 'signup-mode': _ctx.signupMode, 'overlay__subdue-app' : _ctx.showAppChrome && _ctx.userOnboardStatusProp && _ctx.userOnboardStatusProp.isOnboarding && (_ctx.currentStep.banner || _ctx.currentStep.dialog) })
  }, [
    _createVNode(_Transition, { name: "app-boot-fade" }, {
      default: _withCtx(() => [
        (_ctx.appBooting)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("img", {
                src: _ctx.appBootLogo,
                alt: "Ditto",
                class: "app-boot__mark"
              }, null, 8, _hoisted_2)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (_ctx.showAppChrome)
      ? (_openBlock(), _createBlock(_component_Onboarding, { key: 0 }))
      : _createCommentVNode("", true),
    (_ctx.showAppChrome && _ctx.showExpiredSubscriptionModal)
      ? (_openBlock(), _createBlock(_component_ExpiredSubscrption, { key: 1 }))
      : _createCommentVNode("", true),
    (_ctx.showAppChrome && _ctx.userOnboardStatusProp && _ctx.userOnboardStatusProp.isOnboarding && !_ctx.userOnboardStatusProp.showDialog && !_ctx.signupMode && !_ctx.hideOnboardingOnMobile && !_ctx.hideOnboardingByAccess)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_el_progress, {
                type: "circle",
                percentage: (_ctx.currentStepNumber/4) * 100,
                "stroke-width": "10",
                "text-inside": "false",
                color: "#00a887",
                width: "50",
                class: "me-4"
              }, null, 8, ["percentage"]),
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createElementVNode("p", _hoisted_8, "You're on step " + _toDisplayString(_ctx.currentStepNumber) + " of 4.", 1)
              ]),
              _createVNode(_component_el_button, {
                class: "glare mt-4 mt-md-0 ms-md-4",
                type: "primary",
                onClick: _ctx.onStartOnboarding
              }, {
                default: _withCtx(() => [
                  (_ctx.userOnboardStatusProp.step > 1)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode("Finish ")
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode("Start ")
                      ], 64)),
                  _createTextVNode(" Setup ")
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.$route.meta && !_ctx.$route.meta.noAuth)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", {
              class: "hamburger-container",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleMobileNavHandler && _ctx.toggleMobileNavHandler(...args)))
            }, _hoisted_12),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("span", _hoisted_14, [
                (_ctx.companyLogo)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      class: "Header-logo-img",
                      src: _ctx.companyLogo,
                      alt: ""
                    }, null, 8, _hoisted_15))
                  : (_openBlock(), _createElementBlock("img", {
                      key: 1,
                      class: "Header-logo-img",
                      src: require('./assets/images/dt-default-logo.png'),
                      alt: ""
                    }, null, 8, _hoisted_16))
              ])
            ]),
            (_ctx.orgName)
              ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_ctx.orgName), 1))
              : _createCommentVNode("", true)
          ]),
          (_ctx.me)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createVNode(_component_el_tooltip, {
                    content: "Check out what's new in Ditto!",
                    placement: "bottom-end",
                    "hide-after": 0
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        class: "release-notification__button release-notification__icon",
                        onClick: _ctx.onReleaseClick
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Icon, {
                            icon: _ctx.mdiBullhorn,
                            class: "dt-icon--large icon--white"
                          }, null, 8, ["icon"])
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _: 1
                  }),
                  (_ctx.me.showReleaseNotification)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_20))
                    : _createCommentVNode("", true)
                ]),
                _createVNode(_component_el_popover, {
                  placement: "bottom-end",
                  visible: _ctx.accountPopoverEnabled,
                  "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.accountPopoverEnabled) = $event)),
                  "popper-class": "el-popper--subnav",
                  "hide-after": 0
                }, {
                  reference: _withCtx(() => [
                    _createElementVNode("div", null, [
                      _createVNode(_component_el_tooltip, {
                        disabled: _ctx.accountPopoverEnabled,
                        content: _ctx.me.name,
                        placement: "bottom-end",
                        "hide-after": 0
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", {
                            class: _normalizeClass(["top-menu__account", { toggled : _ctx.accountPopoverEnabled }])
                          }, [
                            (_openBlock(), _createElementBlock("svg", _hoisted_21, [
                              _createElementVNode("path", { d: _ctx.mdiAccount }, null, 8, _hoisted_22)
                            ])),
                            (_openBlock(), _createElementBlock("svg", _hoisted_23, [
                              _createElementVNode("path", { d: _ctx.mdiChevronDown }, null, 8, _hoisted_24)
                            ]))
                          ], 2)
                        ]),
                        _: 1
                      }, 8, ["disabled", "content"])
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.me.name), 1)
                    ]),
                    _createElementVNode("ul", _hoisted_27, [
                      _createElementVNode("li", {
                        class: _normalizeClass({ active : _ctx.$route.path.includes(_ctx.me.id)}),
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.accountPopoverEnabled = false))
                      }, [
                        _createVNode(_component_router_link, {
                          to: '/users/' + _ctx.me.id
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("My Account")
                          ]),
                          _: 1
                        }, 8, ["to"])
                      ], 2),
                      (_ctx.isAdmin)
                        ? (_openBlock(), _createElementBlock("li", {
                            key: 0,
                            class: _normalizeClass({ active : _ctx.$route.path.includes('users') && !_ctx.$route.path.includes(_ctx.me.id)}),
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.accountPopoverEnabled = false))
                          }, [
                            _createVNode(_component_router_link, { to: "/users" }, {
                              default: _withCtx(() => [
                                _createTextVNode("Users")
                              ]),
                              _: 1
                            })
                          ], 2))
                        : _createCommentVNode("", true),
                      (_ctx.isAdmin)
                        ? (_openBlock(), _createElementBlock("li", {
                            key: 1,
                            class: _normalizeClass({ active : _ctx.$route.path.includes('roles')}),
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.accountPopoverEnabled = false))
                          }, [
                            _createVNode(_component_router_link, { to: "/roles" }, {
                              default: _withCtx(() => [
                                _createTextVNode("Signage Roles")
                              ]),
                              _: 1
                            })
                          ], 2))
                        : _createCommentVNode("", true),
                      (_ctx.hasBillingAccess)
                        ? (_openBlock(), _createElementBlock("li", {
                            key: 2,
                            class: _normalizeClass({ active : _ctx.$route.path.includes('billing')}),
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.accountPopoverEnabled = false))
                          }, [
                            _createVNode(_component_router_link, { to: "/organization/billing" }, {
                              default: _withCtx(() => [
                                _createTextVNode("Billing")
                              ]),
                              _: 1
                            })
                          ], 2))
                        : _createCommentVNode("", true),
                      _hoisted_28,
                      _createElementVNode("li", {
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.accountPopoverEnabled = false))
                      }, _hoisted_30),
                      _createElementVNode("li", {
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.accountPopoverEnabled = false))
                      }, [
                        _createVNode(_component_router_link, {
                          to: "/logout",
                          class: "nav_child-link"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Log Out")
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ]),
                  _: 1
                }, 8, ["visible"])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _hoisted_31,
    _createElementVNode("section", null, [
      (_ctx.$route.meta && !_ctx.$route.meta.noAuth)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["side-nav__container new-nav", { collapsed : _ctx.navCollapsedAuto, mobile: _ctx.mobileNavToggled }]),
            ref: "sideNavContainer"
          }, [
            _createElementVNode("ul", _hoisted_32, [
              _createVNode(_component_el_tooltip, {
                disabled: !_ctx.navCollapsedAuto,
                content: "Dashboard",
                "hide-after": 0,
                placement: "right"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("li", {
                    class: _normalizeClass(["side-nav__item", { active : _ctx.$route.path == '/'}]),
                    onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.toggleMobileNavHandler && _ctx.toggleMobileNavHandler(...args)))
                  }, [
                    _createVNode(_component_router_link, {
                      class: "side-nav__link",
                      to: "/"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(), _createElementBlock("svg", _hoisted_33, _hoisted_35)),
                        _hoisted_36
                      ]),
                      _: 1
                    })
                  ], 2)
                ]),
                _: 1
              }, 8, ["disabled"]),
              _createVNode(_component_el_tooltip, {
                disabled: !_ctx.navCollapsedAuto,
                content: "Users",
                "hide-after": 0,
                placement: "right"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("li", {
                    class: _normalizeClass(["side-nav__item", { active : _ctx.$route.path.includes('users')}]),
                    onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.toggleMobileNavHandler && _ctx.toggleMobileNavHandler(...args)))
                  }, [
                    (_ctx.hasSuperAccess)
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 0,
                          class: "side-nav__link",
                          to: "/admin/users/"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(), _createElementBlock("svg", _hoisted_37, _hoisted_39)),
                            _hoisted_40
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ], 2)
                ]),
                _: 1
              }, 8, ["disabled"]),
              _createVNode(_component_el_tooltip, {
                disabled: !_ctx.navCollapsedAuto,
                content: "Organizations",
                "hide-after": 0,
                placement: "right"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("li", {
                    class: _normalizeClass(["side-nav__item", { active : _ctx.$route.path.includes('organization')}]),
                    onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.toggleMobileNavHandler && _ctx.toggleMobileNavHandler(...args)))
                  }, [
                    (_ctx.hasSuperAccess)
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 0,
                          class: "side-nav__link",
                          to: "/admin/organizations/"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(), _createElementBlock("svg", _hoisted_41, _hoisted_43)),
                            _hoisted_44
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ], 2)
                ]),
                _: 1
              }, 8, ["disabled"]),
              _createVNode(_component_el_tooltip, {
                ref: "receiversNavigationItem",
                disabled: !_ctx.navCollapsedAuto,
                content: "Receivers",
                "hide-after": 0,
                placement: "right"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("li", {
                    class: _normalizeClass(["side-nav__item", { active : _ctx.$route.path.includes('receivers')}])
                  }, [
                    (_ctx.hasReceiversAccess)
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 0,
                          onClick: _withModifiers(_ctx.receiverNavigationClick, ["prevent"]),
                          class: _normalizeClass([{
                                'overlay__list-item' : (_ctx.userOnboardStatusProp && _ctx.userOnboardStatusProp.showDialog && _ctx.userOnboardStatusProp.isOnboarding && (_ctx.currentStep.guideStepId == 'overviewReceivers' || _ctx.currentStep.guideStepId == 'receiversClickReceivers')),
                                'overlay__click-target' : (_ctx.userOnboardStatusProp && _ctx.userOnboardStatusProp.showDialog && _ctx.userOnboardStatusProp.isOnboarding && _ctx.currentStep.guideStepId == 'receiversClickReceivers')
                                }, "side-nav__link"]),
                          to: "/receivers"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(), _createElementBlock("svg", _hoisted_45, _hoisted_48)),
                            _hoisted_49
                          ]),
                          _: 1
                        }, 8, ["onClick", "class"]))
                      : _createCommentVNode("", true)
                  ], 2)
                ]),
                _: 1
              }, 8, ["disabled"]),
              _createVNode(_component_el_tooltip, {
                disabled: !_ctx.navCollapsedAuto,
                content: "Rooms",
                "hide-after": 0,
                placement: "right"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("li", {
                    class: _normalizeClass(["side-nav__item", { active : _ctx.$route.path.includes('rooms')}])
                  }, [
                    (_ctx.hasRoomsAccess)
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 0,
                          onClick: _withModifiers(_ctx.roomNavigationClick, ["prevent"]),
                          class: _normalizeClass([{ 
                                'overlay__list-item' : _ctx.userOnboardStatusProp && _ctx.userOnboardStatusProp.showDialog && _ctx.userOnboardStatusProp.isOnboarding && (_ctx.currentStep.guideStepId == 'overviewRooms' || _ctx.currentStep.guideStepId == 'roomsClickRooms'),
                                'overlay__click-target' : _ctx.userOnboardStatusProp && _ctx.userOnboardStatusProp.showDialog && _ctx.userOnboardStatusProp.isOnboarding && (_ctx.currentStep.guideStepId == 'roomsClickRooms')
                                }, "side-nav__link"]),
                          to: "/rooms"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(), _createElementBlock("svg", _hoisted_50, _hoisted_52)),
                            _hoisted_53
                          ]),
                          _: 1
                        }, 8, ["onClick", "class"]))
                      : _createCommentVNode("", true)
                  ], 2)
                ]),
                _: 1
              }, 8, ["disabled"]),
              _createVNode(_component_el_tooltip, {
                disabled: !_ctx.navCollapsedAuto,
                content: "Locations",
                "hide-after": 0,
                placement: "right"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("li", {
                    class: _normalizeClass(["side-nav__item", { active : _ctx.$route.path.includes('locations')}]),
                    onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.toggleMobileNavHandler && _ctx.toggleMobileNavHandler(...args)))
                  }, [
                    (_ctx.hasLocationsAccess)
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 0,
                          class: "side-nav__link",
                          to: "/locations"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(), _createElementBlock("svg", _hoisted_54, _hoisted_56)),
                            _hoisted_57
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ], 2)
                ]),
                _: 1
              }, 8, ["disabled"]),
              (_ctx.hasSignageAccess)
                ? (_openBlock(), _createBlock(_component_el_popover, {
                    key: 0,
                    placement: "right",
                    visible: _ctx.signagePopoverEnabled,
                    "onUpdate:visible": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.signagePopoverEnabled) = $event)),
                    "popper-class": "el-popper--subnav side-nav__org-popover",
                    disabled: !_ctx.navCollapsedAuto,
                    "hide-after": 0
                  }, {
                    reference: _withCtx(() => [
                      _createElementVNode("li", {
                        onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.sigangeSubNavToggleHandler && _ctx.sigangeSubNavToggleHandler(...args))),
                        class: _normalizeClass(["side-nav__item side-nav__item--expandable", { active : _ctx.$route.path.includes('signage') && (_ctx.navCollapsedAuto || (!_ctx.navCollapsedAuto && !_ctx.signageSubNavExpanded)), toggled : _ctx.signagePopoverEnabled, expanded: _ctx.signageSubNavExpanded}])
                      }, [
                        _createVNode(_component_el_tooltip, {
                          disabled: !_ctx.navCollapsedAuto || _ctx.signagePopoverEnabled,
                          content: "Signage",
                          "hide-after": 0,
                          placement: "right"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("a", _hoisted_58, [
                              _hoisted_59,
                              _hoisted_60,
                              (_openBlock(), _createElementBlock("svg", {
                                class: _normalizeClass(["side-nav__chevron", _ctx.navCollapsedAuto ? 'side-nav__chevron--right' : 'side-nav__chevron--down']),
                                viewBox: "0 0 24 24"
                              }, [
                                _createElementVNode("path", {
                                  d: _ctx.navCollapsedAuto ? _ctx.mdiChevronRight : _ctx.mdiChevronDown
                                }, null, 8, _hoisted_61)
                              ], 2))
                            ])
                          ]),
                          _: 1
                        }, 8, ["disabled"])
                      ], 2)
                    ]),
                    default: _withCtx(() => [
                      (_ctx.hasSignageAccess)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_62, _hoisted_64))
                        : _createCommentVNode("", true),
                      _createElementVNode("ul", _hoisted_65, [
                        (_ctx.hasSignageAccess)
                          ? (_openBlock(), _createElementBlock("li", {
                              key: 0,
                              onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.toggleMobileNavHandler(), _ctx.signagePopoverEnabled = false)),
                              class: _normalizeClass({ active : _ctx.$route.path.includes('signage') && !_ctx.$route.path.includes('layouts')})
                            }, [
                              _createVNode(_component_router_link, { to: "/signage" }, {
                                default: _withCtx(() => [
                                  _hoisted_66
                                ]),
                                _: 1
                              })
                            ], 2))
                          : _createCommentVNode("", true),
                        (_ctx.hasSignageLayoutAccess)
                          ? (_openBlock(), _createElementBlock("li", {
                              key: 1,
                              onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.toggleMobileNavHandler(), _ctx.signagePopoverEnabled = false)),
                              class: _normalizeClass({ active : _ctx.$route.path.includes('layouts')})
                            }, [
                              _createVNode(_component_router_link, { to: "/signage/layouts" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Layouts")
                                ]),
                                _: 1
                              })
                            ], 2))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _: 1
                  }, 8, ["visible", "disabled"]))
                : _createCommentVNode("", true),
              _createVNode(_Transition, {
                name: "slide-in-top",
                onAfterLeave: _ctx.updateNavShadow,
                onAfterEnter: _ctx.updateNavShadow
              }, {
                default: _withCtx(() => [
                  (!_ctx.navCollapsedAuto && _ctx.signageSubNavExpanded)
                    ? (_openBlock(), _createElementBlock("ul", {
                        key: "sub-nav",
                        class: "side-nav side-nav--sub-nav side-nav__org-side-nav",
                        onClick: _cache[16] || (_cache[16] = _withModifiers(() => {}, ["stop"]))
                      }, [
                        (_ctx.hasSignageAccess)
                          ? (_openBlock(), _createElementBlock("li", {
                              key: 0,
                              class: _normalizeClass([{ active : _ctx.$route.path.includes('signage') && !_ctx.$route.path.includes('layouts')}, "side-nav__item"])
                            }, [
                              _createVNode(_component_router_link, {
                                class: "side-nav__link",
                                to: "/signage"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_67
                                ]),
                                _: 1
                              })
                            ], 2))
                          : _createCommentVNode("", true),
                        (_ctx.hasSignageLayoutAccess)
                          ? (_openBlock(), _createElementBlock("li", {
                              key: 1,
                              class: _normalizeClass([{ active : _ctx.$route.path.includes('layouts')}, "side-nav__item"])
                            }, [
                              _createVNode(_component_router_link, {
                                class: "side-nav__link",
                                to: "/signage/layouts"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_68
                                ]),
                                _: 1
                              })
                            ], 2))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["onAfterLeave", "onAfterEnter"]),
              (_ctx.hasAlertsAccess)
                ? (_openBlock(), _createBlock(_component_el_tooltip, {
                    key: 1,
                    disabled: !_ctx.navCollapsedAuto,
                    content: "Alerts",
                    "hide-after": 0,
                    placement: "right"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("li", {
                        class: _normalizeClass(["side-nav__item", { active : _ctx.$route.path.includes('alerts') && !_ctx.$route.path.includes('alertservers')}]),
                        onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.toggleMobileNavHandler && _ctx.toggleMobileNavHandler(...args)))
                      }, [
                        _createVNode(_component_router_link, {
                          class: "side-nav__link",
                          to: "/alerts"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(), _createElementBlock("svg", _hoisted_69, _hoisted_71)),
                            _hoisted_72
                          ]),
                          _: 1
                        })
                      ], 2)
                    ]),
                    _: 1
                  }, 8, ["disabled"]))
                : _createCommentVNode("", true),
              (_ctx.hasOrganizationAccess || _ctx.hasBillingAccess || _ctx.hasAlertsAccess)
                ? (_openBlock(), _createBlock(_component_el_popover, {
                    key: 2,
                    placement: "right",
                    visible: _ctx.organizationPopoverEnabled,
                    "onUpdate:visible": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.organizationPopoverEnabled) = $event)),
                    "popper-class": "el-popper--subnav side-nav__org-popover",
                    disabled: !_ctx.navCollapsedAuto,
                    "hide-after": 0
                  }, {
                    reference: _withCtx(() => [
                      _createElementVNode("li", {
                        onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.orgSubNavToggleHandler && _ctx.orgSubNavToggleHandler(...args))),
                        class: _normalizeClass(["side-nav__item side-nav__item--expandable", { active : _ctx.$route.path.includes('organization') && (_ctx.navCollapsedAuto || (!_ctx.navCollapsedAuto && !_ctx.organizationSubNavExpanded)), toggled : _ctx.organizationPopoverEnabled, expanded: _ctx.organizationSubNavExpanded}])
                      }, [
                        _createVNode(_component_el_tooltip, {
                          disabled: !_ctx.navCollapsedAuto || _ctx.organizationPopoverEnabled,
                          content: "My Organization",
                          "hide-after": 0,
                          placement: "right"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("a", _hoisted_73, [
                              (_openBlock(), _createElementBlock("svg", _hoisted_74, _hoisted_76)),
                              _hoisted_77,
                              (_openBlock(), _createElementBlock("svg", {
                                class: _normalizeClass(["side-nav__chevron", _ctx.navCollapsedAuto ? 'side-nav__chevron--right' : 'side-nav__chevron--down']),
                                viewBox: "0 0 24 24"
                              }, [
                                _createElementVNode("path", {
                                  d: _ctx.navCollapsedAuto ? _ctx.mdiChevronRight : _ctx.mdiChevronDown
                                }, null, 8, _hoisted_78)
                              ], 2))
                            ])
                          ]),
                          _: 1
                        }, 8, ["disabled"])
                      ], 2)
                    ]),
                    default: _withCtx(() => [
                      (_ctx.hasOrganizationAccess || _ctx.hasBillingAccess || _ctx.hasAlertsAccess)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_79, _hoisted_81))
                        : _createCommentVNode("", true),
                      _createElementVNode("ul", _hoisted_82, [
                        (_ctx.hasOrganizationAccess)
                          ? (_openBlock(), _createElementBlock("li", {
                              key: 0,
                              onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.toggleMobileNavHandler(), _ctx.organizationPopoverEnabled = false)),
                              class: _normalizeClass({ active : _ctx.$route.path.includes('company')})
                            }, [
                              _createVNode(_component_router_link, { to: "/organization/company" }, {
                                default: _withCtx(() => [
                                  _hoisted_83
                                ]),
                                _: 1
                              })
                            ], 2))
                          : _createCommentVNode("", true),
                        (_ctx.hasOrganizationAccess)
                          ? (_openBlock(), _createElementBlock("li", {
                              key: 1,
                              onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.toggleMobileNavHandler(), _ctx.organizationPopoverEnabled = false)),
                              class: _normalizeClass({ active : _ctx.$route.path.includes('customization')})
                            }, [
                              _createVNode(_component_router_link, { to: "/organization/customization" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Customization")
                                ]),
                                _: 1
                              })
                            ], 2))
                          : _createCommentVNode("", true),
                        (_ctx.hasOrganizationAccess)
                          ? (_openBlock(), _createElementBlock("li", {
                              key: 2,
                              onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.toggleMobileNavHandler(), _ctx.organizationPopoverEnabled = false)),
                              class: _normalizeClass({ active : _ctx.$route.path.includes('deployment')})
                            }, [
                              _createVNode(_component_router_link, { to: "/organization/deployment" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Deployment")
                                ]),
                                _: 1
                              })
                            ], 2))
                          : _createCommentVNode("", true),
                        (_ctx.hasBillingAccess)
                          ? (_openBlock(), _createElementBlock("li", {
                              key: 3,
                              onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.toggleMobileNavHandler(), _ctx.organizationPopoverEnabled = false)),
                              class: _normalizeClass({ active : _ctx.$route.path.includes('billing')})
                            }, [
                              _createVNode(_component_router_link, { to: "/organization/billing" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Billing")
                                ]),
                                _: 1
                              })
                            ], 2))
                          : _createCommentVNode("", true),
                        (_ctx.hasOrganizationAccess)
                          ? (_openBlock(), _createElementBlock("li", {
                              key: 4,
                              onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.toggleMobileNavHandler(), _ctx.organizationPopoverEnabled = false)),
                              class: _normalizeClass({ active : _ctx.$route.path.includes('reports')})
                            }, [
                              _createVNode(_component_router_link, { to: "/organization/reports" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Reports")
                                ]),
                                _: 1
                              })
                            ], 2))
                          : _createCommentVNode("", true),
                        (_ctx.hasAlertsAccess)
                          ? (_openBlock(), _createElementBlock("li", {
                              key: 5,
                              onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.toggleMobileNavHandler(), _ctx.organizationPopoverEnabled = false)),
                              class: _normalizeClass({ active : _ctx.$route.path.includes('alertservers')})
                            }, [
                              _createVNode(_component_router_link, { to: "/alertservers" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Alert Servers")
                                ]),
                                _: 1
                              })
                            ], 2))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _: 1
                  }, 8, ["visible", "disabled"]))
                : _createCommentVNode("", true),
              _createVNode(_Transition, {
                name: "slide-in-top",
                onAfterLeave: _ctx.updateNavShadow,
                onAfterEnter: _ctx.updateNavShadow
              }, {
                default: _withCtx(() => [
                  (!_ctx.navCollapsedAuto && _ctx.organizationSubNavExpanded)
                    ? (_openBlock(), _createElementBlock("ul", {
                        key: "sub-nav",
                        class: "side-nav side-nav--sub-nav side-nav__org-side-nav",
                        onClick: _cache[26] || (_cache[26] = _withModifiers(() => {}, ["stop"]))
                      }, [
                        (_ctx.hasOrganizationAccess)
                          ? (_openBlock(), _createElementBlock("li", {
                              key: 0,
                              class: _normalizeClass([{ active : _ctx.$route.path.includes('company')}, "side-nav__item"])
                            }, [
                              _createVNode(_component_router_link, {
                                class: "side-nav__link",
                                to: "/organization/company"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_84
                                ]),
                                _: 1
                              })
                            ], 2))
                          : _createCommentVNode("", true),
                        (_ctx.hasOrganizationAccess)
                          ? (_openBlock(), _createElementBlock("li", {
                              key: 1,
                              class: _normalizeClass([{ active : _ctx.$route.path.includes('customization')}, "side-nav__item"])
                            }, [
                              _createVNode(_component_router_link, {
                                class: "side-nav__link",
                                to: "/organization/customization"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_85
                                ]),
                                _: 1
                              })
                            ], 2))
                          : _createCommentVNode("", true),
                        (_ctx.hasOrganizationAccess)
                          ? (_openBlock(), _createElementBlock("li", {
                              key: 2,
                              class: _normalizeClass([{ active : _ctx.$route.path.includes('deployment')}, "side-nav__item"])
                            }, [
                              _createVNode(_component_router_link, {
                                class: "side-nav__link",
                                to: "/organization/deployment"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_86
                                ]),
                                _: 1
                              })
                            ], 2))
                          : _createCommentVNode("", true),
                        (_ctx.hasBillingAccess)
                          ? (_openBlock(), _createElementBlock("li", {
                              key: 3,
                              class: _normalizeClass([{ active : _ctx.$route.path.includes('billing')}, "side-nav__item"])
                            }, [
                              _createVNode(_component_router_link, {
                                class: "side-nav__link",
                                to: "/organization/billing"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_87
                                ]),
                                _: 1
                              })
                            ], 2))
                          : _createCommentVNode("", true),
                        (_ctx.hasOrganizationAccess)
                          ? (_openBlock(), _createElementBlock("li", {
                              key: 4,
                              class: _normalizeClass([{ active : _ctx.$route.path.includes('reports')}, "side-nav__item"])
                            }, [
                              _createVNode(_component_router_link, {
                                class: "side-nav__link",
                                to: "/organization/reports"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_88
                                ]),
                                _: 1
                              })
                            ], 2))
                          : _createCommentVNode("", true),
                        (_ctx.hasAlertsAccess)
                          ? (_openBlock(), _createElementBlock("li", {
                              key: 5,
                              class: _normalizeClass([{ active : _ctx.$route.path.includes('alertservers')}, "side-nav__item"])
                            }, [
                              _createVNode(_component_router_link, {
                                to: "/alertservers",
                                class: "side-nav__link"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_89
                                ]),
                                _: 1
                              })
                            ], 2))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["onAfterLeave", "onAfterEnter"])
            ], 512),
            _createElementVNode("div", {
              class: _normalizeClass(["nav__footer", { shadowed : _ctx.shadowedNav }]),
              ref: "sideNavFooter"
            }, [
              _hoisted_90,
              _createElementVNode("img", {
                class: "nav__footer-logo nav__footer-logo--large",
                alt: "Ditto",
                src: require('./assets/images/dt-colored-logotype.png')
              }, null, 8, _hoisted_91),
              _createVNode(_component_el_tooltip, {
                content: _ctx.navCollapsedAuto ? 'Expand' : 'Collapse',
                "hide-after": 0,
                placement: "right"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("button", {
                    onClick: _cache[27] || (_cache[27] = 
//@ts-ignore
(...args) => (_ctx.navCollapseHandler && _ctx.navCollapseHandler(...args))),
                    class: "nav__nav-toggle"
                  }, [
                    (_openBlock(), _createElementBlock("svg", _hoisted_92, [
                      _createElementVNode("path", {
                        d: _ctx.navCollapsedAuto ? _ctx.mdiArrowCollapseRight : _ctx.mdiArrowCollapseLeft
                      }, null, 8, _hoisted_93)
                    ]))
                  ])
                ]),
                _: 1
              }, 8, ["content"]),
              _createElementVNode("img", {
                class: "nav__footer-logo nav__footer-logo--small",
                alt: "Ditto",
                src: require('./assets/images/DittoIconRGB.png')
              }, null, 8, _hoisted_94)
            ], 2)
          ], 2))
        : _createCommentVNode("", true),
      (_ctx.$route.meta && !_ctx.$route.meta.noAuth)
        ? (_openBlock(), _createElementBlock("div", _hoisted_95, [
            _createElementVNode("div", _hoisted_96, [
              _createElementVNode("div", _hoisted_97, [
                _createVNode(_component_el_affix, {
                  position: "bottom",
                  offset: 80
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_popover, {
                      placement: "left",
                      title: "Need Help?",
                      width: 300,
                      trigger: "click"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", null, [
                          _hoisted_98,
                          _createElementVNode("div", _hoisted_99, [
                            _createElementVNode("a", _hoisted_100, [
                              _createVNode(_component_el_button, { type: "primary" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Open Support Ticket")
                                ]),
                                _: 1
                              })
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_101, [
                _createVNode(_component_router_view)
              ])
            ])
          ]))
        : (_openBlock(), _createBlock(_component_router_view, {
            key: 2,
            class: "app-view"
          }))
    ])
  ], 2))
}